export const TITLE = 'Confirm Address';
export const DESCRIPTION = 'Bank statement / Utility bill';
export const DB_PREFIX = 'mainAddress';
